import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../Assets/logo.jpg';

const HomePage = () => {
  const { t } = useTranslation('home');

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 font-sans">
      {/* Header */}
      <header className="flex justify-between items-center px-8 py-6 bg-white shadow-md sticky top-0 z-50">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="GenIaC Logo" className="h-10 w-auto object-contain" />
          <span className="text-blue-600 text-2xl font-bold">GenIaC</span>
        </div>

        <nav className="flex items-center space-x-6 text-gray-700 font-medium">
          <Link to="/" className="hover:text-blue-600 transition">{t('header.nav.home')}</Link>
          <a href="#solutions" className="hover:text-blue-600 transition">{t('header.nav.solutions')}</a>
          <a href="#tarifs" className="hover:text-blue-600 transition">{t('header.nav.pricing')}</a>
         <Link to="/home" className="hover:text-blue-600 transition">{t('header.nav.demo')}</Link>
          <a href="#blog" className="hover:text-blue-600 transition">{t('header.nav.blog')}</a>
          <Link to="/login" className="hover:text-blue-600 transition">{t('header.nav.login')}</Link>
          <Link to="/register">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              {t('header.nav.signup')}
            </button>
          </Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="text-center py-20 bg-white">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          {t('hero.title')}
        </h1>
        <p className="text-lg max-w-2xl mx-auto text-gray-600">
          {t('hero.subtitle')}
        </p>
      </section>

      {/* Features */}
      <section id="solutions" className="py-20 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          <Feature
            title={t('features.visualDesign.title')}
            description={t('features.visualDesign.description')}
          />
          <Feature
            title={t('features.costEstimation.title')}
            description={t('features.costEstimation.description')}
          />
          <Feature
            title={t('features.autoDeployment.title')}
            description={t('features.autoDeployment.description')}
          />
          <Feature
            title={t('features.multiClient.title')}
            description={t('features.multiClient.description')}
          />
          <Feature
            title={t('features.dashboard.title')}
            description={t('features.dashboard.description')}
          />
          <Feature
            title={t('features.integration.title')}
            description={t('features.integration.description')}
          />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-6 text-center text-sm text-gray-500">
        {t('footer.copyright', { year: new Date().getFullYear() })}
      </footer>
    </div>
  );
};

interface FeatureProps {
  title: string;
  description: string;
  image?: string;
}

const Feature: React.FC<FeatureProps> = ({ title, description, image }) => (
  <div className="text-center p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition">
    {image && (
      <img
        src={image}
        alt={title}
        className="mx-auto mb-4"
        style={{ width: '60px' }}
      />
    )}
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-600 text-sm">{description}</p>
  </div>
);

export default HomePage;
